import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';
import { Mode } from '@bingads-webui-react/app-layout-container';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { StyledCollapsibleSideBar } from '@bingads-webui-campaign-react/main-menu';
import { isNavigationRefreshOn } from '@bingads-webui-react/preference-utility';
import { StaticItemList, DynamicItemList } from './components';
import { getMainMenuStyles } from './styles/main-menu-styles';

const staticMenuItems = [
  {
    Id: 'defualt-reports-button',
    Name: _TL_('Default reports'),
    glyphIconName: 'ba-ReportDocument',
    logCategory: 'DefaultReport', // for telemetry
    pathname: '/campaign/vnext/reports-v4/default-reports',
  },
  {
    Id: 'my-reports-button',
    Name: _TL_('My reports'),
    glyphIconName: 'ba-Configuration',
    logCategory: 'SavedReport', // for telemetry
    pathname: '/campaign/vnext/reports-v4/my-reports',
  },
];

const staticMenuItemsCustomReportBuilder = [
  {
    Id: 'home-button',
    Name: _TL_('Home'),
    glyphIconName: 'ba-Home',
    logCategory: 'ReportHome', // for telemetry
    pathname: '/campaign/vnext/reporting/home',
  },
  {
    Id: 'templates-button',
    Name: _TL_('Templates'),
    glyphIconName: 'ba-ReportDocument',
    logCategory: 'ReportTemplates', // for telemetry
    pathname: '/campaign/vnext/reporting/templates',
  },
];

function isItemSelectedByPath(currentPath, itemPath) {
  return currentPath === itemPath;
}

class ReportsV4MainMenuView extends React.PureComponent {
  dealLegacyItems = (items) => {
    let currentItems = items;
    if (window.location.pathname.includes('reports-v4/create/pricefeedstatusreport')) {
      currentItems = items.filter(report => report.ReportType !== 'UIPriceFeedStatusReport');
      currentItems.unshift({
        Name: 'Price feed status',
        ReportType: 'UIPriceFeedStatusReport',
      });
    }
    if (window.location.pathname.includes('reports-v4/create/matchingreport')) {
      currentItems = items.filter(report => report.ReportType !== 'UIMatchingReport');
      currentItems.unshift({
        Name: 'Matching',
        ReportType: 'UIMatchingReport',
      });
    }
    return currentItems;
  };
  generateStaticItems = (items, i18n) => {
    const { location } = this.props;

    return items.map(item => ({
      ...item,
      Name: i18n.getString(item.Name),
      isSelected: isItemSelectedByPath(location.pathname, item.pathname),
    }));
  };

  generateDynamicItems = (items, i18n, reportTypeMapping, isCustomReportBuilder) => {
    const { location } = this.props;
    const dynamicItems = this.dealLegacyItems(items);
    const results = dynamicItems.map((item) => {
      const result = {
        ...item,
        logCategory: 'RecentReport', // for telemetry
      };

      if (item.Id) { // Saved report
        result.pathname = isCustomReportBuilder ? `/campaign/vnext/reporting/edit/${item.Id}` : `/campaign/vnext/reports-v4/edit/${item.Id}`;
      } else { // Default report
        const config = reportTypeMapping[item.ReportType];
        if (!config) {
          // The report is not available due to permission or scope
          return null;
        }
        result.Name = i18n.getString(config.name);
        result.pathname = `/campaign/vnext/${config.route}`;
      }

      result.isSelected = isItemSelectedByPath(location.pathname, result.pathname);

      return result;
    });

    return _.compact(results);
  };

  render() {
    const {
      mode,
      i18n,
      onStaticItemClick,
      onDynamicItemClick,
      reports,
      onToggle,
      isPanelMode,
      reportTypeMapping,
      permissions,
    } = this.props;
    const isNavRefresh = isNavigationRefreshOn(permissions);
    const isExpanded = isPanelMode || mode === Mode.Expanded || isNavRefresh;
    const isCustomReportBuilder = permissions && permissions.dynamic && permissions.dynamic.CustomReports;
    const isCustomReportBuilderPhaseTwo = permissions && permissions.dynamic && permissions.dynamic.CustomReportBuilder;

    return (
      <StyledCollapsibleSideBar
        mode={mode}
        isPanelMode={isPanelMode}
        onToggle={onToggle}
        i18n={i18n}
      >
        <StaticItemList
          isExpanded={isExpanded}
          items={this.generateStaticItems(isCustomReportBuilder ? staticMenuItemsCustomReportBuilder : staticMenuItems, i18n)}
          onMenuItemClick={onStaticItemClick}
          classList={['top-menu-item-list']}
        />
        <DynamicItemList
          isExpanded={isExpanded}
          items={this.generateDynamicItems(reports, i18n, reportTypeMapping, isCustomReportBuilderPhaseTwo)}
          onMenuItemClick={onDynamicItemClick}
          i18n={i18n}
        />
        {/* {reports.length >= 10 ?
          <span style={{ position: 'absolute', bottom: 0, width: '100%' }}>
            <StaticItem
              key={bottomMenuItem.Id}
              node={bottomMenuItem}
              renderText={isExpanded ? bottomMenuItem.Name : null}
              onItemClick={onMenuItemClick}
            />
          </span> :
          null
        } */}
      </StyledCollapsibleSideBar>
    );
  }
}

ReportsV4MainMenuView.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  mode: PropTypes.string.isRequired,
  onToggle: PropTypes.func.isRequired,
  onStaticItemClick: PropTypes.func.isRequired,
  onDynamicItemClick: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  reports: PropTypes.arrayOf(PropTypes.shape({})),
  isPanelMode: PropTypes.bool.isRequired,
  reportTypeMapping: PropTypes.shape({}).isRequired,
  permissions: PropTypes.shape({
    dynamic: {
      CustomReportBuilder: PropTypes.bool,
    },
  }).isRequired,
  classes: PropTypes.shape({
    container: PropTypes.string,
  }).isRequired,
};

ReportsV4MainMenuView.defaultProps = {
  reports: [],
};

export const StyledReportsV4MainMenuView = withDefaultStyles(ReportsV4MainMenuView, getMainMenuStyles);
